import { StatusWithDueDate } from '../apis/nhe-remediation-service/nhe-remediation-service.dtos';

export const StatusDisplayMap: Record<StatusWithDueDate, string> = {
  [StatusWithDueDate.NOT_STARTED]: 'Not Started',
  [StatusWithDueDate.IN_PROGRESS]: 'In Progress',
  [StatusWithDueDate.COMPLETED_FAILED]: 'Completed - Failed',
  [StatusWithDueDate.COMPLETED_PASSED]: 'Completed - Passed',
  [StatusWithDueDate.COMPLETED_FAILED_PAST_DUE]: 'Completed Past Due - Failed',
  [StatusWithDueDate.COMPLETED_PASSED_PAST_DUE]: 'Completed Past Due - Passed',
};

export enum ViewOptionValue {
  ONE_AT_A_TIME = 'ONE_AT_A_TIME',
  ALL_ACTIVITIES = 'ALL_ACTIVITIES'
}
